import { ReactNode } from 'react'
import { MessageActionTypes } from '@weblite/ts-action/message'
import { useMessageAction } from '$logic/message-action/react-hook'
import { ACTION_MAPPER } from './chat-list-item-hooks'

// TODO: Move pvMessageActionContent to logic directory
export function pvMessageActionContent(
  messageActions: { userId: string; action: MessageActionTypes }[],
) {
  if (!messageActions?.length) return null

  const [{ action }] = messageActions
  return ACTION_MAPPER[action]
}

export const usePvMessageAction = (roomId: string): ReactNode => {
  const messageActions = useMessageAction(roomId)
  return pvMessageActionContent(messageActions)
}
